module.exports = __webpack_public_path__ + "static/media/waybill-blog-house.b41fb6c4.webp";